import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';
import styles from './content-slider.styl';

@VODCSSModules(styles)
export default class ContentSlider extends React.Component {

  static propTypes = {
    currentPageNumber: React.PropTypes.number,
    width: React.PropTypes.number.isRequired,
    children: React.PropTypes.any,

    onTransitionStart: React.PropTypes.func,
    onTransitionEnd: React.PropTypes.func,
  };

  componentDidMount() {
    this.subscribeToTransitionEnd();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPageNumber !== this.props.currentPageNumber) {
      this.props.onTransitionStart();
    }
  }

  componentWillUnmount() {
    this.unsubscribeFromTransitionEnd();
  }

  @autobind
  handleTransitionCompleted() {
    this.props.onTransitionEnd();
  }

  subscribeToTransitionEnd() {
    this.contentNode.addEventListener('transitionend', this.handleTransitionCompleted);
  }

  unsubscribeFromTransitionEnd() {
    this.contentNode.removeEventListener('transitionend', this.handleTransitionCompleted);
  }

  @autobind
  saveContentRef(node) {
    this.contentNode = node;
  }

  get currentPageOffset() {
    const { currentPageNumber, width } = this.props;
    return {
      transform: `translate3d(${-1 * currentPageNumber * width}px, 0, 0)`,
    };
  }

  render() {
    const { children } = this.props;

    return (
      <section styleName="container">
        <div styleName="content"
             data-hook="contentSliderContent"
             style={this.currentPageOffset}
             ref={this.saveContentRef}>
          {children}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/content-slider/content-slider.js